import React from 'react';

import PRODUCTS from './ProductDataTypes';
import {getSiteConfig} from '../config';

const SITE_CONFIG = getSiteConfig();


const generateResourceId = (id) => {
    return PRODUCTS.PARAGARD+"_"+id;
};


const paragardData =
{
    id: PRODUCTS.PARAGARD,
    alt:"Paragard",
    title:(<React.Fragment>Paragard<sup>&reg;</sup></React.Fragment>),
    productImages: [
            require('../assets/images/paragard/paragard-product-img.png'),
            require('../assets/images/paragard/paragard-product-img@2x.png'),
            require('../assets/images/paragard/paragard-product-img@3x.png')
        ],
    description:'',
    videoData:{
        videoSets2:[],
        videoSets:[
            {
                isChapterBased:true,
                videos:[
                    {
                        resourceId:generateResourceId("vs1v1"),
                        title:"Chapter 1",
                        subTitle: "Preparation",
                        description: null,
                        wistiaId:"68zzxuhgtf",
                        wistiaConfig:{
                            padding:"56.25% 0 0 0"
                        }
                    },
                    {
                        resourceId:generateResourceId("vs1v2"),
                        title:"Chapter 2",
                        subTitle: "Loading",
                        description: null,
                        wistiaId:"rkbgm7dl42",
                        wistiaConfig:{
                            padding:"56.25% 0 0 0"
                        }
                    },
                    {
                        resourceId:generateResourceId("vs1v3"),
                        title:"Chapter 3",
                        subTitle: "Placement",
                        description: null,
                        wistiaId:"kpmvf3lrmc",
                        wistiaConfig:{
                            padding:"56.25% 0 0 0"
                        }
                    },
                    {
                        resourceId:generateResourceId("vs1v4"),
                        title:"Chapter 4",
                        subTitle: "Removal",
                        description: null,
                        wistiaId:"8razr1ax0n",
                        wistiaConfig:{
                            padding:"56.25% 0 0 0"
                        }
                    }
                ]

            }
        ]
    },
    documentData:{
        documents2:[],
        documents:[
            {
                resourceId: generateResourceId("d1"),
                title:"Paragard Prescription Information",
                description:null,
                url:SITE_CONFIG.DOC_SITE_DEFAULT_URL+"/docs/Paragard Prescription Information.pdf",
                thumbnails:[
                    require("../assets/images/doc-thumbnails/thumbnail_paragard-information.jpg"),
                    require("../assets/images/doc-thumbnails/thumbnail_paragard-information@2x.jpg"),
                    require("../assets/images/doc-thumbnails/thumbnail_paragard-information@3x.jpg")
                ]
            }
        ]
    }
    ,externalProductId:"PARAGARD"
};


export default paragardData;








